import KHR from '../assets/ccy/khr.svg';
import USD from '../assets/ccy/usd.svg';
interface QrCodeProps{
  url: string;
  currency: string;
  amount: string
}

export function QRCodeImage({ url, currency, amount } : QrCodeProps){
  return (
    <div className="w-[260px] bg-white rounded-2xl p-0">
      <div className="w-full">
          <div className="w-full flex justify-center items-center p-4  bg-[#e21a1a] rounded-t-2xl text-white">
            <img fetchPriority="high" src="/khqr-icon.svg" alt="KHQR" width={36}/>
          </div> 
          <div className="w-full flex justify-end">
              <div className="triangle-top-right"></div>
          </div> 
          <div className="merc-khqr-info khqr-font ">
            <span className="text-[14px]">
                53 Cloud
            </span> 
            <div className="flex justify-center items-center mt-1">
              <span>
                <div className="w-full flex items-center gap-x-2 font-bold">
                  { currency === 'USD' ? Number(amount).toFixed(2) : amount}
                  <span className="text-[8px] font-normal">{currency}</span>
                </div>
              </span>
            </div>
          </div>
          <div className="w-full pt-[12%] pb-[8%] px-[10%] flex justify-center">
            <div className='relative'>
              <img fetchPriority="high" width={100} height={250} src={url} alt="qrcode-img"  className="w-full" /> 
              <img fetchPriority="high" src={currency==='USD'? USD : KHR} width={35} className='absolute left-[42%] top-[42%]' alt="" />
            </div>
          </div>
      </div>
    </div>
  )
}